<script setup lang="ts">
import { RouterView } from 'vue-router'
import FullPageLoader from '@/components/ui/FullPageLoader.vue'
import { useAuth } from '@/lib/auth/useAuth'

// Nothing routes until the session is restored — the guard in
// src/router/index.ts is awaiting the same promise.
const { status } = useAuth()
</script>

<template>
  <FullPageLoader v-if="status === 'loading'" />
  <RouterView v-else />
</template>
